import {
  COLLECTION_STORE,
  ONLY_MEMBER
} from '@components/LocalMerchant/Coupons/constant'
import { COUPONS_PATH_A } from '@constant'
import {
  isWeddingDressProperty,
  isWeddingPlanProperty,
  isWeddingRingJewelryProperty
} from '@merchant-backend/util'
import { getMerchantInfo, isHotelMerchant } from '@util'
import { Badge, Switch } from 'hljd'
import moment from 'moment'
import React from 'react'

const COUPON = {
  '1': '普通',
  '2': '特殊'
}

export default (store, open) => {
  const isHotel = isHotelMerchant()
  const { is_special_merchant } = getMerchantInfo()
  const isHSLFPropertyOrisHLCHProperty =
    isWeddingDressProperty() ||
    isWeddingPlanProperty() ||
    isWeddingRingJewelryProperty()

  return [
    {
      title: '备注',
      dataIndex: 'title',
      width: 102
    },
    {
      title: '金额',
      width: 56,
      render: ({ value }) => <span>{value}</span>
    },
    {
      title: '类型',
      dataIndex: 'coupon_type',
      width: 102,
      render: coupon_type => {
        return COUPON[coupon_type + '']
      }
    },
    {
      title: '使用范围',
      dataIndex: 'scope',
      width: 100,
      render: (scope, { coupon_type, use_case }) => {
        if (isHotel) {
          switch (use_case) {
            case 0:
              return '其他优惠'

            case 1:
              return '菜单费优惠'

            case 2:
              return '场地费优惠'

            case 3:
              return '订单费优惠'

            case 4:
              return '试菜费优惠'

            default:
              return '-'
          }
        } else {
          if (coupon_type == 2) {
            return '-'
          }
          switch (scope) {
            case 0:
              return '-'

            case 1:
              return '全场'

            case 2:
              return '指定套餐'

            default:
              return '-'
          }
        }
      }
    },
    {
      title: '使用条件',
      width: 84,
      render: ({ type, money_sill, property_name = [] }) => {
        let html
        if (type + '' === '1' && property_name.length > 0) {
          html = (
            <span>
              满{money_sill}且限{property_name.join('、')}套餐使用
            </span>
          )
        } else if (type + '' === '1' && property_name.length == 0) {
          html = <span>满{money_sill}</span>
        } else if (type + '' !== '1' && property_name.length > 0) {
          html = <span>限{property_name.join('、')}套餐使用</span>
        } else {
          html = <span>无</span>
        }

        return html
      }
    },
    {
      title: '领取条件',
      width: 86,
      render: ({ condition_of_get }) => (
        <span>
          {condition_of_get == ONLY_MEMBER && '会员'}
          {condition_of_get == COLLECTION_STORE && '加入收藏'}
          {condition_of_get != ONLY_MEMBER &&
            condition_of_get != COLLECTION_STORE &&
            '无'}
        </span>
      ),
      hidden: () =>
        isHotel ||
        isHSLFPropertyOrisHLCHProperty ||
        isWeddingRingJewelryProperty()
    },
    {
      title: '领取时间',
      width: 170,
      render: ({ provide_start, provide_end }) => {
        if (isHotel) {
          const nowDate = moment().format('YYYY-MM-DD')
          const isExpire = nowDate > provide_end

          return (
            <div>
              <p>
                <span style={{ color: '#999' }}>从：</span>
                <span style={{ color: isExpire ? '#ff6766' : '#666' }}>
                  {provide_start.substring(0, 11)}
                </span>
              </p>
              <p>
                <span style={{ color: '#999' }}>到：</span>
                <span style={{ color: isExpire ? '#ff6766' : '#666' }}>
                  {provide_end.substring(0, 11)}
                </span>
              </p>
            </div>
          )
        }

        return (
          <div>
            <p>
              <span style={{ color: '#999' }}>从：</span>
              {provide_start.substring(0, 11)}
            </p>
            <p>
              <span style={{ color: '#999' }}>到：</span>
              {provide_end.substring(0, 11)}
            </p>
          </div>
        )
      }
    },
    {
      title: '有效期',
      dataIndex: 'time',
      width: 170,
      render: (o, { valid_start, valid_end, valid_type, valid_day }) => {
        valid_start = valid_start || ''
        valid_end = valid_end || ''
        if (isHotel) {
          if (valid_type == 1) {
            const nowDate = moment().format('YYYY-MM-DD')
            const isAfter = nowDate >= valid_start
            const isBefore = nowDate <= valid_end
            const isExpire = nowDate > valid_end
            return (
              <div>
                <p>
                  <span style={{ color: '#999' }}>从：</span>
                  <span
                    style={{
                      color:
                        isBefore && isAfter
                          ? '#379b0d'
                          : isExpire
                            ? '#ff6766'
                            : '#666'
                    }}
                  >
                    {valid_start.substring(0, 11)}
                  </span>
                </p>
                <p>
                  <span style={{ color: '#999' }}>到：</span>
                  <span
                    style={{
                      color:
                        isBefore && isAfter
                          ? '#379b0d'
                          : isExpire
                            ? '#ff6766'
                            : '#666'
                    }}
                  >
                    {valid_end.substring(0, 11)}
                  </span>
                </p>
              </div>
            )
          } else if (valid_type == 2) {
            return <div>领取后{valid_day}日过期</div>
          }
          return null
        }

        return (
          <div>
            <p>
              <span style={{ color: '#999' }}>从：</span>
              {valid_start.substring(0, 11)}
            </p>
            <p>
              <span style={{ color: '#999' }}>到：</span>
              {valid_end.substring(0, 11)}
            </p>
          </div>
        )
      }
    },
    {
      title: '激活状态',
      width: 70,
      render: ({ id, hidden, condition_of_get }) => (
        <Switch
          checkedChildren="开"
          unCheckedChildren="关"
          checked={hidden == 1}
          onChange={store.checkStatus(
            id,
            condition_of_get,
            isHSLFPropertyOrisHLCHProperty,
            hidden
          )}
          disabled={is_special_merchant == 2}
        />
      )
    },
    {
      title: '发行量',
      width: 60,
      render: ({ total_count }) => <span>{total_count}</span>
    },
    {
      title: '已领取',
      width: 60,
      render: ({ provided_count, id, title, new_customer_count }) => {
        const count = (
          <a
            target="__blank"
            style={{ marginRight: 4 }}
            href={`${COUPONS_PATH_A}/receive/${id}?title=${title}`}
          >
            {provided_count}
          </a>
        )
        return +provided_count || 0 ? (
          <Badge dot={+new_customer_count > 0}>{count}</Badge>
        ) : (
          <Badge dot={+new_customer_count > 0}>0</Badge>
        )
      }
    },
    {
      title: '在线使用',
      width: 74,
      render: ({ online_used_count }) => <span>{online_used_count || 0}</span>,
      hidden: () => isHotel
    },
    {
      title: '到店使用',
      width: 74,
      render: ({ offline_used_count }) => <span>{offline_used_count || 0}</span>
    },
    {
      title: '操作',
      width: 54,
      render: ({ id }) =>
        is_special_merchant != 2 ? (
          <a style={{ color: '#448afc' }} onClick={store.toEdit(id, open)}>
            编辑
          </a>
        ) : (
          <span style={{ color: '#ccc' }}>编辑</span>
        )
    }
  ]
}
